import { apiSlice } from "../api/apiSlice";

export const assignmentApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAssignment: builder.query({
      query: (video_id) => ({
        url: `/assignments/?video_id=${video_id}`,
        method: "GET",
      }),
      providesTags: ["Assignmentbyvideoid"],
    }),
    getSingleAssignment: builder.query({
      query: (assignmentId) => ({
        url: `/assignments/?id=${assignmentId}`,
        method: "GET",
      }),
      providesTags: (result, error, arg) => [
        { type: "SingleAssignment", id: arg },
      ],
    }),
    getAllAssignments: builder.query({
      query: () => ({
        url: "/assignments",
        method: "GET",
      }),
      providesTags: ["Assignments"],
    }),
    addAssignment: builder.mutation({
      query: (data) => ({
        url: "/assignments",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Assignments", "Assignmentbyvideoid"],
    }),
    editAssignment: builder.mutation({
      query: ({ id, data }) => ({
        url: `/assignments/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result, error, arg) => [
        "Assignments",
        { type: "SingleAssignment", id: arg },
      ],
    }),

    deleteAssignment: builder.mutation({
      query: (id) => ({
        url: `/assignments/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, arg) => [
        "Assignments",
        "Assignmentbyvideoid",
      ],
    }),
  }),
});

export const {
  useGetAssignmentQuery,
  useGetAllAssignmentsQuery,
  useAddAssignmentMutation,
  useDeleteAssignmentMutation,
  useGetSingleAssignmentQuery,
  useEditAssignmentMutation,
} = assignmentApi;
